export default __webpack_public_path__ + "static/media/carrosel-image-01.4144833d.png";